import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-blue-200 text-white shadow-lg md:px-0 px-4">
      <div className="flex justify-between items-center px-6 bg-green-200">
        <div className="text-2xl font-bold">
          <img className="w-[80px] h-[80px]" src="CT.png" alt="Edgecore Logo" />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <Link to="/" className="hover:text-white text-blue-950 font-bold">
            Home
          </Link>
          <Link to="/about-us" className="hover:text-white text-blue-950 font-bold">
            About Us
          </Link>
          <Link to="/service" className="hover:text-white text-blue-950 font-bold">
            Services
          </Link>
          <Link to="/contactus" className="hover:text-white text-blue-950 font-bold">
            Contact Us
          </Link>
          {/* Add Job Seeking Link */}
          <Link to="/job" className="hover:text-white text-blue-950 font-bold">
            Job Seeking
          </Link>
        </nav>

        {/* Mobile Menu Toggle Button */}
        <button
          className="md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-blue-700">
          <nav className="flex flex-col space-y-4 px-6 py-4">
            <Link to="/" className="hover:text-yellow-300">
              Home
            </Link>
            <Link to="/about-us" className="hover:text-yellow-300">
              About Us
            </Link>
            <Link to="/service" className="hover:text-yellow-300">
              Services
            </Link>
            <Link to="/contactus" className="hover:text-yellow-300">
              Contact Us
            </Link>
            {/* Add Job Seeking Link to Mobile Menu */}
            <Link to="/job" className="hover:text-yellow-300">
              Job Seeking
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
